import { HeadMetadata } from "@hub/models/metadata/head-metadata";
import { Breadcrumb } from "@hub/models/ui/breadcrumb";
import { hubOriginUrl, hubSiteTree } from "@hub/services/config.service";
import { getBreadCrumbs } from "@hub/services/content/common/get-breadcrumbs";
import { createUrlPath } from "@hub/services/utils/path.utils";
import { HubPage } from "apps/hub/components/hub-page";
import type { NextPage } from "next";
import { GetStaticProps } from "next";
import React from "react";

interface IndexProps {
  canonicalUrl: string;
  breadcrumbs?: Breadcrumb[];
}

const Index: NextPage<IndexProps> = ({ canonicalUrl, breadcrumbs }) => {
  const headMetadata: HeadMetadata = {
    title: "Auth0 Developer Resources",
    description:
      "Get access to Auth0 code samples and technical guides that cover different frameworks, languages, and platforms.",
    url: canonicalUrl,
    image:
      "https://cdn.auth0.com/website/developer-center/preview-cards/resources.png",
    type: "website",
  };

  return (
    <HubPage
      breadcrumbs={breadcrumbs}
      canonicalUrl={canonicalUrl}
      headMetadata={headMetadata}
    />
  );
};

export default Index;

export const getStaticProps: GetStaticProps<IndexProps> = async () => {
  const breadcrumbs = getBreadCrumbs({
    root: {
      label: hubSiteTree.root.displayName,
      path: hubSiteTree.root.urlPath,
    },
  });

  const canonicalUrl = hubOriginUrl + createUrlPath([hubSiteTree.root.urlPath]);

  const props: IndexProps = {
    canonicalUrl,
    breadcrumbs,
  };

  return {
    props,
  };
};
